import axios from 'axios'

/** Hláška z backendu (ErrorResponse.message), jinak předaná náhrada. */
export function errorMessage(err: unknown, fallback: string): string {
  if (axios.isAxiosError(err)) {
    const message = (err.response?.data as { message?: string } | undefined)?.message
    if (message) return message
  }
  return fallback
}
